import { createFileRoute, Outlet } from '@tanstack/react-router'
import { VoiceFabProvider } from '@/features/tarefas/voz/VoiceFab'

// O botão de voz mora no layout para aparecer na lista e no quadro.
export const Route = createFileRoute('/_app/app/tarefas')({
  component: () => (
    <VoiceFabProvider>
      <Outlet />
    </VoiceFabProvider>
  ),
})
